import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DragIndicatorIcon(props: IconProps) {
    return <Icon {...props} iconKey={"drag_indicator"}/>
}
